import { lazy } from "react";

export const BasicEdPDF = lazy(() => import("./BasicEd"));
export const CollegePDF = lazy(() => import("./College"));
export const MastersPDF = lazy(() => import("./Masters"));
export const SEEProgramPDF = lazy(() => import("./SEEProgram"));
